import request from '@/utils/request';

/**
 * 支付服务 - 处理支付相关API请求
 */
class PaymentService {
  /**
   * 创建支付订单
   * @param {Object} data - 订单数据
   * @returns {Promise} 创建订单响应
   */
  createOrder(data) {
    return request.post('/api/payment/create_order', data);
  }

  /**
   * 创建微信支付订单
   * @returns {Promise} 微信支付订单响应，包含支付二维码
   */
  createWechatPayment() {
    return request.post('/api/payment/wechat/create', {});
  }

  /**
   * 查询订单状态
   * @param {string} orderId - 订单ID
   * @returns {Promise} 订单状态响应
   */
  checkOrderStatus(orderId) {
    return request.get(`/api/payment/check_order/${orderId}`);
  }

  /**
   * 获取用户订单历史
   * @param {Object} params - 查询参数
   * @returns {Promise} 订单历史响应
   */
  getOrderHistory(params) {
    return request.get('/api/payment/orders', params);
  }

  /**
   * 获取产品列表
   * @returns {Promise} 产品列表响应
   */
  getProducts() {
    return request.get('/api/payment/products');
  }

  /**
   * 申请退款
   * @param {string} orderId - 订单ID
   * @param {Object} data - 退款数据
   * @returns {Promise} 退款申请响应
   */
  applyRefund(orderId, data) {
    return request.post(`/api/payment/refund/${orderId}`, data);
  }
}

export default new PaymentService(); 